var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTiff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 42,
    viewBox: "0 0 36 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_142_31)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.3 29.4H3V25.9L0 29.5C0 29.5 0.1 29.4 0.2 29.4H0.3Z",
    fill: "#AA98A9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9999 1H30.0999C31.4999 1 32.5999 2.1 32.5999 3.4V38.8C32.5999 40.1 31.4999 41.2 30.0999 41.2H5.3999C3.9999 41.2 2.8999 40.1 2.8999 38.8V10.7",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9999 1H30.0999C31.4999 1 32.5999 2.1 32.5999 3.4V38.8C32.5999 40.1 31.4999 41.2 30.0999 41.2H5.3999C3.9999 41.2 2.8999 40.1 2.8999 38.8V10.7",
    stroke: "#696969",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8999 0.400024V8.20002C12.8999 9.60002 11.7999 10.7 10.2999 10.7H2.3999",
    fill: "#696969"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.8 29.4H33V25.9L36 29.5C36 29.5 36 29.4 35.8 29.4Z",
    fill: "#AA98A9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.2 37.2001C33.2 37.4001 32.9 37.6 32.6 37.6H3.4C3.2 37.6 2.9 37.4001 2.8 37.2001L0 29.7001C0 29.6001 0 29.4 0.1 29.3H35.7C35.7 29.3 36 29.3 36 29.5C36 29.6 33.2 37 33.2 37V37.2001Z",
    fill: "#696969"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2 10.2C21 10.2 24.1 13.3 24.1 17.1C24.1 20.9 21 24 17.2 24C13.4 24 10.3 20.9 10.3 17.1C10.3 13.3 13.4 10.2 17.2 10.2ZM17.2 23C20.5 23 23.1 20.4 23.1 17.1C23.1 13.8 20.5 11.2 17.2 11.2C13.9 11.2 11.3 13.8 11.3 17.1C11.3 20.4 13.9 23 17.2 23Z",
    fill: "#AA98A9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.5 25.6C25.4 25.6 25.2 25.6 25.1 25.5L21.6 22C21.4 21.8 21.4 21.5 21.6 21.3C21.8 21.1 22.1 21.1 22.3 21.3L25.8 24.8C26 25 26 25.3 25.8 25.5C25.8 25.5 25.6 25.6 25.4 25.6H25.5Z",
    fill: "#AA98A9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 19.6H21.4L18.4 15.4L16.6 18L15.5 16.3L13 19.6Z",
    fill: "#AA98A9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9001 14.8C16.3419 14.8 16.7001 14.4418 16.7001 14C16.7001 13.5581 16.3419 13.2 15.9001 13.2C15.4583 13.2 15.1001 13.5581 15.1001 14C15.1001 14.4418 15.4583 14.8 15.9001 14.8Z",
    fill: "#AA98A9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3082 31.5703V30.9091H15.2482V31.5703H13.6598V36H12.8942V31.5703H11.3082ZM16.887 30.9091V36H16.1189V30.9091H16.887ZM18.0056 36V30.9091H21.1626V31.5703H18.7737V33.1214H20.9363V33.7802H18.7737V36H18.0056ZM22.1072 36V30.9091H25.2641V31.5703H22.8753V33.1214H25.0379V33.7802H22.8753V36H22.1072Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_142_31"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 42,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiff);
export default __webpack_public_path__ + "static/media/TIFF.1ff80b264280206b2df6e1a734d65a2c.svg";
export { ForwardRef as ReactComponent };